<script>

    import LocationSelectComponent from './component.select.svelte'

    export let location = {}

</script>

<div class="columns">
    <div class="column">
        <LocationSelectComponent bind:location={ location } showButtons={false} showSwitchs={false} />
    </div>
</div>